<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Roles & Permissions</div>
    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input
          matInput
          (keyup)="applyFilter()"
          matInput
          type="text"
          [(ngModel)]="searchValue"
        />
      </mat-form-field>
    </div>
    <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button
      *ngIf="showNewRole"
      mat-button
      color="lightGreen"
      (click)="createNewRole()"
    >
      Create New Role
    </button>
  </div>
</div>

<div class="roles-list">
  <div class="container roles-container">
    <div class="container-header no-bottom-border">
      <div class="text">Roles</div>
      <div class="options">
        <button
          *ngIf="showNewRole"
          mat-icon-button
          [matMenuTriggerFor]="rolesMenu"
        >
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu class="mat-menu-elaphant vertical-menu" #rolesMenu="matMenu">
          <button
            *ngIf="showNewRole"
            class="icon-btn-w-text"
            mat-menu-item
            (click)="createNewRole()"
          >
            <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
            <span>Create New Role</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="container-content">
      <table #rolesTable mat-table [dataSource]="roleDataSource" matSort>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Role Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="number_of_users">
          <th mat-header-cell *matHeaderCellDef mat-sort-header># Members</th>
          <td mat-cell *matCellDef="let element">
            {{ element.number_of_users ? element.number_of_users : "None" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Creation Date
          </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.created_at">
              {{ formatDate(element.created_at) }}
            </span>
            <span *ngIf="!element.created_at"> - </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="created_by_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
          <td mat-cell *matCellDef="let element">
            {{ element.created_by_name ? element.created_by_name : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="modified_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Last Modified
          </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.modified_at">
              {{ formatDate(element.modified_at) }}
            </span>
            <span *ngIf="!element.modified_at"> - </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="modified_by_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Modified By</th>
          <td mat-cell *matCellDef="let element">
            {{ element.modified_by_name ? element.modified_by_name : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="options-cell">
            <button
              *ngIf="showCopy"
              mat-button
              (click)="copy(element)"
              class="icon-btn"
            >
              <svg-icon src="assets/svg/copy.svg"></svg-icon>
            </button>
            <div *ngIf="!showCopy" class="empty-btn-space"></div>

            <button
              *ngIf="showEdit"
              mat-button
              (click)="edit(element)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/pencil.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div *ngIf="!showEdit" class="empty-btn-space"></div>

            <button
              *ngIf="showDelete"
              mat-button
              (click)="delete(element)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/trashcan.svg"
                [svgStyle]="{
                  'width.px': '15.25',
                  'height.px': '16.204'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div *ngIf="!showDelete" class="empty-btn-space"></div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
